export enum ActionType {
  Info = 'info',
  Warn = 'warn',
  Success = 'success',
  Danger = 'danger',
  Other = 'other',
}